var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiSparkle = function SvgAiSparkle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 1.83333C9.66667 5.58333 11.6667 7.58333 15.4167 8.08333C11.6667 8.58333 9.66667 10.5833 9.16667 14.3333C8.66667 10.5833 6.66667 8.58333 2.91667 8.08333C6.66667 7.58333 8.66667 5.58333 9.16667 1.83333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.1667C15.7333 13.9167 16.6667 14.85 18.4167 15.0833C16.6667 15.3167 15.7333 16.25 15.5 18C15.2667 16.25 14.3333 15.3167 12.5833 15.0833C14.3333 14.85 15.2667 13.9167 15.5 12.1667Z",
    fill: "currentColor"
  })));
};
export default SvgAiSparkle;